import { FC } from 'react';
import { Link } from 'react-router-dom';
import { HStack } from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';
import SunshineIcon, { IconName } from 'components/_core/SunshineIcon';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';

import locales from './locales';

interface EmptyStateOptionProps {
  icon: IconName;
  mobileOnly?: boolean;
  title: string;
  to?: string;
}

const EmptyStateOption: FC<EmptyStateOptionProps> = ({
  icon,
  mobileOnly,
  title,
  to,
}) => {
  return (
    <SunshineCard alignItems="center" as={mobileOnly ? 'div' : Link} to={to}>
      <SunshineCard.Slot name="aside">
        <SquircleIcon name={icon} />
      </SunshineCard.Slot>

      <SunshineCard.Content spacing="space-8">
        <SunshineCard.Title>{title}</SunshineCard.Title>
      </SunshineCard.Content>

      <SunshineCard.Slot name="action">
        {mobileOnly ? (
          <HStack gap={4}>
            <SunshineIcon color="light" name="mobile" size="icon-14" />
            <Text
              fontWeight="weight-500"
              lineHeight="16px"
              size="xs"
              variant="light"
            >
              {locales.mobileOnly}
            </Text>
          </HStack>
        ) : (
          <SunshineIcon color="light" name="chevron-right" size="icon-24" />
        )}
      </SunshineCard.Slot>
    </SunshineCard>
  );
};

export default EmptyStateOption;
